import { render } from "./Globalnfo.vue?vue&type=template&id=08261ef5"
import script from "./Globalnfo.vue?vue&type=script&lang=js"
export * from "./Globalnfo.vue?vue&type=script&lang=js"

import "./Globalnfo.vue?vue&type=style&index=0&id=08261ef5&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__